export default __webpack_public_path__ + "static/media/HDTX_Pengumuman RUPS 2025.448770db.pdf";